var render = function render(){var _vm=this,_c=_vm._self._c;return _c('MaskLayer',[_c('b-spinner',{attrs:{"variant":"success","label":"Spinning"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }